import { render, staticRenderFns } from "./NomineeSrc.vue?vue&type=template&id=972fd826"
import script from "./NomineeSrc.vue?vue&type=script&lang=js"
export * from "./NomineeSrc.vue?vue&type=script&lang=js"
import style0 from "./NomineeSrc.vue?vue&type=style&index=0&id=972fd826&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports